/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterMetal_viewer$ref: FragmentReference;
export type SbSharedRefineMenuFilterMetal_viewer = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_viewer$ref,
  +$refType: SbSharedRefineMenuFilterMetal_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterMetal_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2798c6c2ba1ab8f683b56930ca3d69ce';
module.exports = node;
